import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IComponentProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'File Viewer',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FileViewer,
    'x-component-props': {
      file: undefined,
      modelInstanceId: undefined,
      displayMode: 'modal',
      label: 'View File',
      type: 'text',
      variant: 'outlined',
      size: 'middle',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
